import { LanguageOptions } from '@blocknox/flow';
import env from '@beam-australia/react-env';

export const loadFlowConfig = (language: LanguageOptions) => {
  const flowBaseUrl = env('FLOW_BASE_URL');
  const flowClientApiKey = env('FLOW_CLIENT_KEY');

  return {
    apiConnectionConfig: {
      baseUrl: flowBaseUrl,
      publishableKey: flowClientApiKey
    },
    language,
    clientName: 'Custody'
  };
};
